import React, { Component } from 'react';

class ImageBox extends Component {

	constructor(props) {
		super(props);
		this.favoritePhoto = this.favoritePhoto.bind(this);	
		this.state = {
			favoredMessage: '',
			favoriteLabelColor: null,
			displayEmptyHeartIcon: 'inline',
  			displayRedHeartIcon: 'none',
  			favoriteOverlayTop: null,
  			modalComponent: 'ImageModalContainer'
		}
		this.openModal = this.openModal.bind(this);
	}

	componentWillMount() {
		if (this.props.favored) {
			this.setState({
				favoriteLabelColor: 'red',
    			displayRedHeartIcon: 'inline',
    			displayEmptyHeartIcon: 'none',
    			favoriteOverlayTop: '0px'
			});
		}
	}

	componentWillReceiveProps(nextProps) {
		if (nextProps.favored) {
			this.setState({
				favoriteLabelColor: 'red',
    			displayRedHeartIcon: 'inline',
    			displayEmptyHeartIcon: 'none',
    			favoriteOverlayTop: '0px'
			});
		}
	}

	openModal() {
		this.props.dispatchOpenModal(this.props.src, this.props.title, this.state.modalComponent);
	}

	favoritePhoto(e) {
		if (this.props.favored) {
      		return;
    	}

		this.props.onAddToFavorites({
			title: this.props.title,
        	url: this.props.src 
		});
	}

	render() {
		return (
			<div className="photo-container">
				{ !this.props.disableFavs &&
					<div className="favorite-overlay" style={{top: this.state.favoriteOverlayTop}}>
						<div className="table">
							<div className="favorite-label">
								<div className="favorite-hover-label" onClick={this.favoritePhoto} style={{color: this.state.favoriteLabelColor}}>
									Favorite: 
									<i className="fa fa-heart-o" style={{display: this.state.displayEmptyHeartIcon}}></i>
									<i className="fa fa-heart" style={{display: this.state.displayRedHeartIcon}}></i>
								</div>
							</div>
						</div>
					</div>
				}
				<div className="open-modal-overlay" onClick={this.openModal}>
					<div className="table">
						<div className="open-modal-label">
							Click to open modal!
						</div>
					</div>
				</div>
				<img className="photo" src={this.props.src} role="presentation" onClick={this.openModal} />
			</div>
		)
	}
}

export default ImageBox;



/** WEBPACK FOOTER **
 ** ./src/image-display/ImageBox.js
 **/